import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import React from 'react';
import {useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import {ReduxState} from '../../state/reducer';
import Api from '../../api';

interface RerenderCompanyContractDialogProps {
    open: boolean;
    companyId?: string;
    version?: number;
    onClose: () => void;
}

const RerenderCompanyContractDialog = (props: RerenderCompanyContractDialogProps) => {
    const company = useSelector((state: ReduxState) => Selector.Company.company(state, props.companyId || ''));

    const rerenderContract = () => {
        if (!company) {return;}

        const booking = props.version ? company.bookings?.[props.version] : undefined;
        Api.Command.generateBookingContract({
            companyId: company.id,
            email: 'noValid@e-mail.insecia', // intentional wrong hardcoded mail to prevent resending of the contract
            bookedQualityCheck: booking?.qualityCheck ?? false,
            rerenderContract: true,
            version: props.version,
        });

        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth={true}>
            <DialogTitle>Vertrag erneut generieren (Version {props.version})</DialogTitle>
            <DialogContent>
                <Typography>
                    Sind Sie sicher, dass Sie den Vertrag für
                    {company?.name || 'das Unternehmen'} (Version {props.version}) neu generieren wollen?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Abbrechen</Button>
                <Button
                    children={'Neu generieren'}
                    variant={'contained'}
                    onClick={rerenderContract}
                />
            </DialogActions>
        </Dialog>
    );
};

export default RerenderCompanyContractDialog;
